var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useContext } from "react";
import { useGAOneLead } from "../utils/hooks/useGAOnLead";
var noopTrackUserAuthentication = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        console.warn("GoogleAnalyticsContext used outside of provider");
        return [2 /*return*/];
    });
}); };
export var GoogleAnalyticsContext = createContext({
    trackUserAuthentication: noopTrackUserAuthentication,
});
export var useGoogleAnalytics = function () { return useContext(GoogleAnalyticsContext); };
export var GoogleAnalyticsProvider = function (_a) {
    var children = _a.children;
    var trackUserAuthentication = useGAOneLead();
    return (<GoogleAnalyticsContext.Provider value={{ trackUserAuthentication: trackUserAuthentication }}>
      {children}
    </GoogleAnalyticsContext.Provider>);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR29vZ2xlQW5hbHl0aWNzUHJvdmlkZXIuanN4Iiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiR29vZ2xlQW5hbHl0aWNzUHJvdmlkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sS0FBSyxFQUFFLEVBQUUsYUFBYSxFQUFFLFVBQVUsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUN6RCxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sNEJBQTRCLENBQUM7QUFTMUQsSUFBTSwyQkFBMkIsR0FBRzs7UUFDbEMsT0FBTyxDQUFDLElBQUksQ0FBQyxpREFBaUQsQ0FBQyxDQUFDOzs7S0FDakUsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLHNCQUFzQixHQUFHLGFBQWEsQ0FDakQ7SUFDRSx1QkFBdUIsRUFBRSwyQkFBMkI7Q0FDckQsQ0FDRixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sa0JBQWtCLEdBQUcsY0FBTSxPQUFBLFVBQVUsQ0FBQyxzQkFBc0IsQ0FBQyxFQUFsQyxDQUFrQyxDQUFDO0FBRTNFLE1BQU0sQ0FBQyxJQUFNLHVCQUF1QixHQUFzQyxVQUFDLEVBRTFFO1FBREMsUUFBUSxjQUFBO0lBRVIsSUFBTSx1QkFBdUIsR0FBRyxZQUFZLEVBQUUsQ0FBQztJQUUvQyxPQUFPLENBQ0wsQ0FBQyxzQkFBc0IsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSx1QkFBdUIseUJBQUEsRUFBRSxDQUFDLENBQ2xFO01BQUEsQ0FBQyxRQUFRLENBQ1g7SUFBQSxFQUFFLHNCQUFzQixDQUFDLFFBQVEsQ0FBQyxDQUNuQyxDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=